import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      -Hej, rapidu, vi malantaŭas! – urĝigas la Granda Montrilo la Malgrandan. 
      – Mi jam tiom da ciferoj trairis, sed vi preskaŭ sur la sama loko restas. 
      Malbone vi servas al la Tempo.
    </p>
    
    <p class="mb-3">
      Strebas la Malgranda Montrilo, sed ne sukcesas. 
      Ĉu povus ŝi akiri la saman rapidecon, kiel la Granda?
    </p>
    
    <p class="mb-3">
      Sed ŝi ja montras horojn, ne minutojn!
    </p>
  `
  )
}

const itemName = {
  esp: 'La tempo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;